// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"309":"a20c9934","8407":"d69dc00d"}[chunkId] + ".chunk.css";
};